import { dayjs } from '@src/libs/date/date';

const dateFormat = 'DD/MM/YYYY';

export const getFilingDate = (date: string) => dayjs(date, dateFormat).toDate();
